import { TaskTypes } from 'context';

export type AttendanceType = {
  attendanceId: string;
  /** Backend student id — used to match join-click hints (spec 0013). */
  studentId?: string;
  studentName: string;
  checked?: boolean;
};

export type LessonAttachmentType = {
  id: string;
  title: string;
  link: string;
};

export enum AttachmentType {
  student = 'student',
  teacher = 'teacher',
}

export enum HomeworkGradesType {
  DONE = 'DONE',
  CONTAINS_ERRORS = 'CONTAINS_ERRORS',
  NOT_DONE = 'NOT_DONE',
}

export type HomeworksType = {
  studentId: string;
  studentName: string;
  gradeType?: HomeworkGradesType | null;
  mark?: number | null;
};

export type ProgramLessonType = {
  id: string;
  name: string;
  index: number;
  isEnded: boolean;
  isActive?: boolean;
  needToFinish?: boolean | null;
};

export type LessonType = ProgramLessonType & {
  /** Human-readable "day, HH:MM-HH:MM" for display. */
  time: string;
  /** Raw lesson times ("19:00:00"), used to compute the Zoom join window. */
  startTime?: string | null;
  endTime?: string | null;
  date: string;
  finished: boolean;
  lmsDescription: string;
  comment: string;
  video?: string | null;
  taskTypes: string[];
  hasStudentMarks?: boolean | null;
  hasTeacherAttachment?: boolean | null;
  hasStudentAttachment?: boolean | null;
  whiteboardId?: string | null;
  homeworkAssignmentId?: string | null;
  /** rev.3: server gate — homework tab is available on every non-diploma
   * lesson, independent of a teacher-authored assignment. */
  homeworkAvailable?: boolean | null;
  /** spec 0013: the group has a configured join link (URL itself is never
   * exposed in queries — only via the lmsJoinLesson mutation). */
  hasJoinLink?: boolean | null;
  /** spec 0013: a temporary link override is active for today. */
  linkOverrideActive?: boolean | null;
};

export type StudentMarks = {
  mark?: number | null;
  hwMark?: HomeworkGradesType | null;
  date: string;
  taskType: TaskTypes;
};
